import { CloseIcon, SearchIcon } from '../../../components/ui/icons';
import { IconButton, InputAdornment, TextField } from '@mui/material';

export function CollectionSearchField({
  label,
  placeholder,
  clearLabel,
  value,
  onChange,
}: {
  label: string;
  placeholder: string;
  clearLabel: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          bgcolor: 'background.paper',
          borderRadius: 1,
        },
        '& .MuiInputAdornment-root': { color: 'text.secondary' },
      }}
      slotProps={{
        htmlInput: { 'aria-label': label },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                aria-label={clearLabel}
                onClick={() => onChange('')}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        },
      }}
    />
  );
}
